import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActionButtonComponent } from './action-button.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ActionButtonComponent],
  imports: [MatButtonModule, CommonModule, TranslateModule.forChild({}), PipesModule, SvgIconModule],
  exports: [ActionButtonComponent],
})
export class ActionButtonModule {}
